// Lib
import { createAction } from '@reduxjs/toolkit';

export const SetSearchActive = createAction('SET_SEARCH_ACTIVE');
